/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Tlm_1Inputs */

const en_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

const ar_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيئة البناء`)
};

const bn_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

const de_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

const es_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tiempo de ejecución_compilación`)
};

const fr_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

const pt_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

const zh_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建运行时`)
};

const tr_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

const ru_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

const pl_svc_mobile_app_development_tlm_1 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`build_runtime`)
};

/**
* | output |
* | --- |
* | "build_runtime" |
*
* @param {Svc_Mobile_App_Development_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_tlm_1 = /** @type {((inputs?: Svc_Mobile_App_Development_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "de") return de_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "es") return es_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_tlm_1(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_tlm_1(inputs)
	return en_svc_mobile_app_development_tlm_1(inputs)
});
export { svc_mobile_app_development_tlm_1 as "svc_mobile-app-development_tlm_1" }